import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  ViewEncapsulation
} from '@angular/core';
import {
  CheckNotes,
  DialRiskLevel,
  InspectionFireAlarmSystem,
  SummaryNotes
} from '@authority-labs/api-interfaces';

@Component({
  selector: 'authority-labs-fire-alarm-system-test-results',
  templateUrl: './fire-alarm-system-test-results.component.html',
  styleUrls: ['./fire-alarm-system-test-results.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.ShadowDom
})
export class FireAlarmSystemTestResultsComponent implements OnInit {
  @Input() inspection: InspectionFireAlarmSystem;

  mainItems: { label: string; value: string; notes: CheckNotes[] }[] = [];
  extraNotes: {
    title: string;
    notes: string[];
    multiNotes?: SummaryNotes[];
  }[] = [];
  notes: string[] = [];
  dialers: DialRiskLevel[] = [];

  ngOnInit(): void {
    const fireAlarmSystemDesign = this.inspection?.fireAlarmSystemDesign;

    this.dialers = [
      fireAlarmSystemDesign?.dialRiskLevelOne,
      fireAlarmSystemDesign?.dialRiskLevelTwo,
      fireAlarmSystemDesign?.dialRiskLevelTwoAccommodation
    ];

    this.mainItems = [
      {
        label: 'מיקום התקנת הרכזת',
        value: fireAlarmSystemDesign.discoveryHub.item_6_1.value,
        notes: fireAlarmSystemDesign.discoveryHub.item_6_1.getNotes()
      },
      {
        label: 'מיקום רכזת משנה',
        value: fireAlarmSystemDesign.discoveryHub.item_6_2.value,
        notes: fireAlarmSystemDesign.discoveryHub.item_6_2.getNotes()
      },
      {
        label: 'תוכנית בטיחות',
        value: fireAlarmSystemDesign.main.safetyPlansDelivered.value,

        notes: fireAlarmSystemDesign.main.safetyPlansDelivered.getNotes()
      },
      {
        label: 'האתר הנבדק מסווג ברמת סיכון',
        value: fireAlarmSystemDesign.main.siteAtRisk.value,
        notes: fireAlarmSystemDesign.main.siteAtRisk.getNotes()
      },
      {
        label: 'האזורים המוגנים',
        value: fireAlarmSystemDesign.main.protectedAreas.value,
        notes: fireAlarmSystemDesign.main.protectedAreas.getNotes()
      }
    ];

    this.extraNotes = [
      fireAlarmSystemDesign.autoDialer,
      fireAlarmSystemDesign.cellularAutoDialer,
      fireAlarmSystemDesign.discoveryHub,
      fireAlarmSystemDesign.detectorsInstallation,
      fireAlarmSystemDesign.beamsAndPartitions,
      fireAlarmSystemDesign.powerPanel,
      fireAlarmSystemDesign.sirensAndMarkingLamps,
      fireAlarmSystemDesign.paSystem,
      fireAlarmSystemDesign.specialInstallations,
      fireAlarmSystemDesign.firefightersPhone,
      fireAlarmSystemDesign.componentsActivation,
      fireAlarmSystemDesign.standaloneDetectors
    ]
      .map((item) => ({
        title: item.title,
        notes: item
          .getNotes()
          .filter((note) => note.addNotesToReport && note.notes)
          .filter((note) => !note.notes.includes('undefined'))
          .map((note) => note.notes),
        multiNotes: item
          .getMultiNotes()
          .filter((note) => note.addNotesToReport && note.notes)
      }))
      .filter((item) => item.notes.length > 0 || item.multiNotes.length > 0);

    this.notes = new InspectionFireAlarmSystem(this.inspection)
      .getNotes()
      .filter((note) => note.addNotesToReport && note.notes)
      .filter((note) => !note.notes.includes('undefined'))
      .map((note) => note.notes);
  }
}
